import { render } from "./Copy.vue?vue&type=template&id=94697636"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"
script.render = render

export default script